<!-- vertical layout -->
<app-vertical-layout [layoutWidth]="layoutWidth" *ngIf="isVerticalLayoutRequested()">
</app-vertical-layout>
